import { render } from "./FTPSettingsForm.vue?vue&type=template&id=34964a0c&scoped=true"
import script from "./FTPSettingsForm.vue?vue&type=script&lang=js"
export * from "./FTPSettingsForm.vue?vue&type=script&lang=js"

import "./FTPSettingsForm.vue?vue&type=style&index=0&id=34964a0c&scoped=true&lang=css"
import "./FTPSettingsForm.vue?vue&type=style&index=1&id=34964a0c&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34964a0c"]])

export default __exports__